// setup monaco
import * as monaco from 'monaco-editor'
import { completionItems } from './utils/type.util';

export const setupMonaco = () => {

  const { CompletionItemKind } = monaco.languages;

  monaco.languages.register({ id: "mustache" })

  monaco.languages.setMonarchTokensProvider("mustache", {
    tokenizer: {
      root: [
        [/\{\{([^\{\}]+)\}\}/, "keyword"],
        [/\{\{/, "type.identifier"],
        [/\}\}/, "type.identifier"],
      ],
    },
  });

  monaco.languages.registerCompletionItemProvider("mustache", {
    provideCompletionItems: (model, position, context, token) => {
      const currentLine = model.getLinesContent()[position.lineNumber - 1];
      const lineContentBeforeCursor = currentLine?.substring(0, position.column - 1);
      const word = model.getWordUntilPosition(position);
      const range = {
        startLineNumber: position.lineNumber,
        endLineNumber: position.lineNumber,
        startColumn: word.startColumn,
        endColumn: word.endColumn,
      };
      const endsWithDoubleMustache = lineContentBeforeCursor?.trim()?.endsWith("{{");
      const suggestions = completionItems.map((c) => {
        return { label: c, insertText: `${c}}}`, kind: CompletionItemKind.Keyword, range }
      });
      if (endsWithDoubleMustache) {
        return { suggestions }
      }
      return;
    },
    triggerCharacters: ["{"],
  });


}